$(document).ready(function(){
    $('body').click(function(){
	setTimeout(function(){
		$.getJSON('/cart.js', function(cart){ 
			var result = cart.total_price;
            //alert(result);
			if(result >= 9900){
              $('.custom-free-shipping').removeClass('custom-free-shipping_hide');
            }else {
              $('.custom-free-shipping').addClass('custom-free-shipping_hide');
            }
		});
	},1000);
});
   

    setTimeout(function(){
    $.getJSON('/cart.js', function(cart){ 
        var result = cart.total_price;
         //alert(result)
        if(result >= 9900){
            $('.custom-free-shipping').removeClass('custom-free-shipping_hide');
        }
    });
}, 1000);
    
  })